import React, { useEffect, useRef, useState } from 'react'
import Skeleton from 'react-loading-skeleton';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';
import { YoutubeEmbedStyle } from './YouTubeEmbed.css'


const parseYouTubeUrl = (youTubeLink) => {
  //var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const regExp = /^(?:https?\:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v\=))([\w-]{10,12})(?:[\&\?\#].*?)*?(?:[\&\?\#]t=([\dhm]+s))?$/;
  var match = youTubeLink.match(regExp);
  return (match&&match[1].length==11)? match[1] : false;
}


const YoutubeEmbed = ({ link }) => {

  const youTubeVideoId = parseYouTubeUrl(link)
  const divRef = useRef(null)
  const isOnScreen = useIntersectionObserver(divRef,"300px")
  const [show,setShow] = useState(false)

  useEffect(()=> {
    if(isOnScreen){
      setShow(true)
    }
  },[isOnScreen])


  return (
    <div ref={divRef} css={YoutubeEmbedStyle}>
    {!youTubeVideoId || !show ?
      <Skeleton /> :
      <iframe
        width='750'
        height='422'
        src={`https://www.youtube-nocookie.com/embed/${youTubeVideoId}`}
        frameBorder='0'
        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
      /> }
    </div>
  )
}

export default YoutubeEmbed
